export const extractSecondLevelDomain = (hostname: string): string => {
    const subdomains = hostname.split('.');
    if (subdomains.length === 1) {
        return hostname;
    } else {
        return subdomains.slice(-2).join('.');
    }
};
